<template>
  <div class='post'>
    <router-link :to="{ name: 'Details', params: { id: post.id }}">
      <h3>{{ post.title }}</h3>
    </router-link>
    <p>{{ snippet }}</p>
    <span class="pill" v-for="tag in post.tags" :key="tag" @click.prevent="$router.push({ name: 'Tags', params: { tag: tag } })">
      #{{ tag }}
    </span>
    <span class="created">{{ formatDate }}</span>
  </div>
</template>

<script>
import { computed } from 'vue'
import { formatDistanceToNow } from 'date-fns'

export default {
  props: ['post'],
  setup(props) {
    const snippet = computed(() => {
      return props.post.body.substring(0, 100) + '...'
    })
    const formatDate = computed(() => {
      return formatDistanceToNow(props.post.createdAt.toDate());
    })
    return { snippet, formatDate }
  }
}
</script>

<style>
  .post {
    margin: 0 40px 30px;
    padding-bottom: 30px;
    border-bottom: 1px dashed #e7e7e7;
  }
  .post h3 {
    display: inline-block;
    position: relative;
    font-size: 26px;
    color: white;
    margin-bottom: 10px;
    max-width: 400px;
  }
  .post h3::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: #ff8800;
    position: absolute;
    z-index: -1;
    padding-right: 40px;
    left: -30px;
    transform: rotateZ(-1deg);
  }
  .post span {
    cursor: pointer;
  }
  .post span.created {
    display: block;
    font-size: 13px;
    color: gray;
    text-align: right;
    margin-right: 3rem;
  }
</style>